import React from 'react';
import { StarfieldBackground } from './components/Shared';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Curriculum } from './components/Curriculum';
import { InsideLook } from './components/InsideLook';
import { Trust } from './components/Trust';
import { Offer } from './components/Offer';
import { PurchasePopups } from './components/PurchasePopups';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-celestial-900 text-slate-200 font-sans selection:bg-gold/30 selection:text-gold-light relative" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StarfieldBackground data-id="element-2" />

      <main className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Curriculum data-id="element-6" />
        <InsideLook data-id="element-7" />
        <Trust data-id="element-8" />
        <Offer data-id="element-9" />
      </main>

      <PurchasePopups data-id="element-10" />
    </div>;
}